var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":_vm.bottom,"top":_vm.top,"left":_vm.left,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticClass:"mx-4 cursor-pointer",attrs:{"color":"grey"}},on),[_vm._v("$info")])]}}])},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }